import React, { Component } from 'react';
import './Footer.css';

interface FooterState {
  copied: boolean;
}

class Footer extends Component<{}, FooterState> {
  state: FooterState = {
    copied: false
  };

  copyEmail = () => {
    navigator.clipboard.writeText('info@audionyx.ai');
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  render() {
    const currentYear = new Date().getFullYear();
    
    return (
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Audionyx</h3>
              <p>Invisible audio identity for voice protection, provenance, and verification.</p>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <button 
                type="button"
                className="email-button"
                onClick={this.copyEmail}
                title="Click to copy email address"
              >
                info@audionyx.ai
                {this.state.copied && <span className="copied-tooltip">Copied!</span>}
              </button>
            </div>
            <div className="footer-section">
              <h4>Follow</h4>
              <div className="footer-social-links">
                <a
                  className="footer-link-button"
                  href="https://youtu.be/JvO8mwyrOy4"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="footer-social-icon youtube-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                      <path d="M9.5 7.5v9l7-4.5-7-4.5z" />
                    </svg>
                  </span>
                  YouTube
                </a>
                <a
                  className="footer-link-button"
                  href="https://www.linkedin.com/in/audionyx-ai-inc-619143385/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="footer-social-icon linkedin-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                      <path d="M6.6 9.1h-3v9.8h3V9.1zM5.1 7.8c1 0 1.7-.7 1.7-1.6s-.7-1.6-1.7-1.6-1.7.7-1.7 1.6.7 1.6 1.7 1.6zM20.6 13.3c0-3-1.6-4.4-3.8-4.4-1.7 0-2.5.9-3 1.6V9.1h-3v9.8h3v-5.4c0-1.4.3-2.8 2-2.8s1.7 1.6 1.7 2.9v5.3h3v-5.6z" />
                    </svg>
                  </span>
                  LinkedIn
                </a>
              </div>
              <a
                className="product-hunt-badge"
                href="https://www.producthunt.com/products/aowl?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-aowl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt="AOWL - Audio Watermark Labs | Product Hunt"
                  width="250"
                  height="54"
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1165990&theme=light&t=1780865211333"
                />
              </a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {currentYear} Audionyx. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
